import React from 'react';
import CategorySection from './CategorySection';

const FeaturedCategories = ({ featuredSubcategories = [] }) => {
  if (!featuredSubcategories || featuredSubcategories.length === 0) {
    return (
      <div className="flex items-center justify-center py-12 text-gray-500">
        <p>No featured categories available</p>
      </div>
    );
  }

  return (
    <div className="py-0">
     
      {/* Render each category section */}
      {featuredSubcategories.map((item) => (
        <CategorySection 
          key={item.category.id}
          categoryData={{
            id: item.category.id,
            name: item.category.name,
            products: item.products
          }} 
        />
      ))}
    </div>
  );
};

export default FeaturedCategories;